import styled from 'styled-components'

import { BrandedBackground } from '@/common/styles'

export const Layout = styled(BrandedBackground)`
  & > div {
    box-sizing: border-box;
    max-width: 436px;
    padding: ${props => props.theme.spacing.sp32};
    border-radius: ${props => props.theme.radius.modal};
    box-shadow: ${props => props.theme.elevation.elevation3};
    background-color: ${props => props.theme.colors.background.primary};
  }

  form {
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.sp8};
  }

  .MuiInputBase-root {
    min-height: 52px;
    background-color: ${props => props.theme.colors.background.secondary};
    border-radius: ${props => props.theme.primitives.radius.radius2} ${props => props.theme.primitives.radius.radius2} 0
      0;
    border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.text.default};
    font-family: ${props => props.theme.fonts.body};
    font-size: ${props => props.theme.primitives.fontSize.fontSize14};
    color: ${props => props.theme.colors.text.default};
  }

  .MuiInputBase-root fieldset {
    border: none;
  }

  .MuiInputBase-root input::placeholder {
    color: ${props => props.theme.colors.text.subtle};
    opacity: 1;
  }

  .MuiInputLabel-root {
    font-family: ${props => props.theme.fonts.body};
    color: ${props => props.theme.colors.text.subtle};
  }

  @media screen and (min-width: 600px) {
    & > div {
      width: 60%;
      max-width: 436px;
    }
  }
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp40};

  & > button {
    font-family: ${props => props.theme.fonts.body};
    font-weight: ${props => props.theme.primitives.fontWeight.bold};
    font-size: ${props => props.theme.primitives.fontSize.fontSize14};
    color: ${props => props.theme.colors.primary.default};
  }
`

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding-top: ${props => props.theme.spacing.sp24};

  p {
    color: ${props => props.theme.colors.danger.default};
    text-align: center;
    font-family: ${props => props.theme.fonts.body};
  }

  button {
    width: 100%;
    height: ${props => props.theme.size.L};
    background-color: ${props => props.theme.colors.primary.default};
    color: ${props => props.theme.colors.primary.on};
    border: none;
    border-radius: ${props => props.theme.radius.button};
    font-family: ${props => props.theme.fonts.body};
    font-weight: ${props => props.theme.primitives.fontWeight.bold};
    font-size: ${props => props.theme.primitives.fontSize.fontSize14};
  }

  button:hover {
    background-color: ${props => props.theme.colors.primary.hover};
  }

  button:disabled {
    background-color: ${props => props.theme.colors.disabled.surface};
    color: ${props => props.theme.colors.disabled.content};
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ReveniLogo = styled.img`
  height: 27px;
`
